<template>
  <v-container fluid>
    <v-card>
      <div class="pr-md-4 border-bottom d-flex align-items-center justify-content-between">
        <PageTitle
          text="Estude agora"
          class="lead"
          :show-border-bottom="false"
        />
      </div>
      <v-tabs
        v-model="tab"
        active-class="nitro text-white"
      >
        <v-tab value="Módulos">
          Módulos
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ModuleTab />
        </v-tab-item>
      </v-tabs-items>
      <ModalChallenge />
    </v-card>
  </v-container>
</template>
<script>

import { mapGetters } from 'vuex'
import HasTabs from "@/common/mixins/HasTabs"
import PageTitle from '@/common/components/PageTitle'
import ModuleTab from '@/student/pages/cycle/components/ModuleTab'
import ModalChallenge from "@/student/components/challenge/ModalChallenge"


export default {
  components: {
    ModuleTab,
    PageTitle,
    ModalChallenge
  },
  mixins:[HasTabs],
  computed: {
    ...mapGetters(['selectedYear']),
  },
}
</script>
